import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSparkles } from "@fortawesome/sharp-solid-svg-icons";
import { ThemedTiles } from "../functions/tile";
import { useRef } from "react";
import { HelpCopy } from "./help-copy";
import "./help-container.css";

function HelpContainerTitle(props) {
    const getAiChatButton = () => {
        if (!props.ShowAiChat) return null;

        return (
            <a className={"eone-help-title-ai-chat-button"} title="Ask questions about this article" onClick={props.OpenAiChatSidebar}>
                <FontAwesomeIcon icon={faSparkles} />
            </a>
        );
    };

    const getTitle = () => {
        if (props.Theme === "web") {
            return <h2>{props.Name}</h2>;
        }

        return <h3>{props.Name}</h3>;
    };

    const getCopyButton = () => {
        if (!props.CopyState) return null;
        return <HelpCopy ContainerRef={props.ContainerRef} ProductName={props.ProductName} CopyState={props.CopyState} />;
    };

    return (
        <div className={"eone-help-title-container"}>
            {getTitle()}
            {getAiChatButton()}
            {getCopyButton()}
        </div>
    );
}

function HelpContainerDescription(props) {
    if (!props.Description) {
        return null;
    }

    return <HelpText Text={props.Description} Class={"eone-help-container-description"} Theme={props.Theme} />;
}

function HelpContainer(props) {
    const containerRef = useRef(null);

    const getContent = () => {
        //todo: could add a show more show less to long description
        return (
            <div className={`eone-help-container-${props.Theme}`}>
                <div className={`eone-help-container-intro-${props.Theme}`}>
                    <HelpContainerTitle
                        ContainerRef={containerRef}
                        ProductName={props.ProductName}
                        CopyState={props.CopyState}
                        Name={props.Name}
                        Theme={props.Theme}
                        ShowAiChat={props.ShowAiChat}
                        OpenAiChatSidebar={props.OpenAiChatSidebar} />
                    <HelpContainerDescription Description={props.Description} Theme={props.Theme} />
                    <HelpContainerDescription Description={props.LongDescription} Theme={props.Theme} />
                </div>
                <div className={`eone-help-container-body-${props.Theme}`}>
                    {props.children}
                </div>
            </div>
        );
    }

    if (props.Visible === false) {
        return null;
    }

    if (props.CopyState) {
        return (
            <div ref={containerRef}>
                {getContent()}
            </div>
        );
    }

    return getContent();
}

function HelpContainerTiles(props) {
    if (!props.Visible) {
        return;
    }

    return (
        <HelpContainer
            ShowCopy={props.Theme !== "web"}
            ProductName={props.ProductName}
            CopyState={props.CopyState}
            Theme={props.Theme}
            Name={props.Name}
            Description={props.Description}
            LongDescription={props.LongDescription}>
            <ThemedTiles
                Visible
                Theme={props.Theme}
                Tiles={props.Tiles}
                OnClick={props.OnClick}
                HideDescription={props.HideTileDescriptions} />
        </HelpContainer>
    );
}

function HelpHeading(props) {
    if (!props.Value) return null;

    if (props.Theme === "web") {
        return <h3>{props.Value}</h3>;
    }

    return <div className="eone-help-heading-sidebar">{props.Value}</div>;
}

function HelpSubheading(props) {
    if (!props.Value) return null;

    if (props.Theme === "web") {
        return <h4>{props.Value}</h4>;
    }

    return <div className="eone-help-subheading-sidebar">{props.Value}</div>;
}

function HelpSection(props) {
    return (
        <div className={`eone-help-section-${props.Theme}`}>
            <HelpHeading Value={props.Heading} Theme={props.Theme} />
            <HelpSubheading Value={props.Subheading} Theme={props.Theme} />
            {props.children}
        </div>
    );
}

function HelpText(props) {
    if (!props.Text) return null;

    let className = props.Class ? props.Class : "";
    if (props.Medium) {
        className += props.Theme === "web" ? " pd-documentation-text-medium" : " pd-default-text-medium";
    }

    if (props.Theme === "web") return <h6 className={className}>{props.Text}</h6>
    return <div className={`eone-help-text-default-sidebar ${className}`}>{props.Text}</div>
}

export { HelpContainer, HelpHeading, HelpSubheading, HelpSection, HelpText, HelpContainerTiles }